import React from "react"

import { ChatBotFlowBlockRule } from "@/protocols/chatBot"
import BlockBodySection from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/BlockBodySection"
import BlockBodySectionRequiredCondition, { ContinueConditionIcon } from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/BlockBodySectionRequiredCondition"
import BlockBodySectionHandle from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/BlockBodySectionHandle"

import { getConditionByValidationSlug } from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/utils/chatBotFlowBlockRule"

type AIValueNotFoundConditionSectionProps = {
	nextChatBotFlowBlockRules: ChatBotFlowBlockRule[]
}

const AIValueNotFoundConditionSection: React.FC<AIValueNotFoundConditionSectionProps> = (props) => {
	const { nextChatBotFlowBlockRules } = props

	const valueNotFoundCondition = getConditionByValidationSlug("contact-value-extraction-found-value", nextChatBotFlowBlockRules)

	if (!valueNotFoundCondition) {
		return null
	}

	return (
		<BlockBodySection>
			<BlockBodySectionHandle
				chatBotFlowBlockRule={valueNotFoundCondition.rule}
			>
				<BlockBodySectionRequiredCondition
					text="Se a IA não encontrar o valor"
					icon={<ContinueConditionIcon />}
				/>
			</BlockBodySectionHandle>
		</BlockBodySection>
	)
}

export default AIValueNotFoundConditionSection
